import {
  IAccounts,
  ICreateBrandsProps,
  ISellerVendorResponse,
} from '@/types/account';
import { apiClient } from '../client';

interface IAccountUpdateWithProfiles {
  profileId: string;
  url?: string;
}
interface UserByEmail {
  id: number;
  username: string;
  email: string;
}
interface AddUserToAccount {
  userId: number;
  accountId: number;
  role: string;
}
// create new account
import { SeatLimitsResponse } from '@/types/account';

export const accountService = {
  // get seat limits
  getSeatLimits: async (): Promise<SeatLimitsResponse> => {
    const { data } = await apiClient.get('/invitations/limits');
    return data;
  },
  createAccount: async (payload: ICreateBrandsProps): Promise<any> => {
    const { data } = await apiClient.post('/accounts', payload);
    return data;
  },
  // Get all the accounts for the current user
  getAccounts: async (): Promise<IAccounts> => {
    const { data } = await apiClient.get('/accounts');

    return data;
  },

  // delete an account
  deleteAccount: async (id: string): Promise<any> => {
    const { data } = await apiClient.delete(`/accounts/${id}`);
    return data;
  },

  // update an account
  updateAccount: async (
    id: string,
    payload: ICreateBrandsProps
  ): Promise<any> => {
    const { data } = await apiClient.patch(`/accounts/${id}`, payload);
    return data;
  },

  // add a profile to an account
  updateAccountWithProfiles: async (
    id: string,
    payload: IAccountUpdateWithProfiles
  ): Promise<any> => {
    const { data } = await apiClient.post(`/accounts/${id}/profiles`, payload);
    return data;
  },

  // remove a profile from an account
  removeProfileFromAccount: async (
    id: string,
    profileId: string
  ): Promise<any> => {
    const { data } = await apiClient.delete(
      `/accounts/${id}/profiles/${profileId}`
    );
    return data; // Return the response data
  },

  removeSellerFromAccount: async (
    id: string,
    sellerId: string
  ): Promise<any> => {
    const { data } = await apiClient.delete(
      `/accounts/${id}/seller/${sellerId}`
    );
    return data;
  },
  removeVendorFromAccount: async (
    id: string,
    sellerId: string
  ): Promise<any> => {
    const { data } = await apiClient.delete(
      `/accounts/${id}/vendor/${sellerId}`
    );
    return data;
  },

  // get seller and vendor accounts
  getSellerVendorAccounts: async (): Promise<ISellerVendorResponse> => {
    const { data } = await apiClient.get('/accounts/seller-vendor');
    return data;
  },

  // search user by email
  getUserEmail: async (email: string): Promise<UserByEmail[]> => {
    const { data } = await apiClient.get(`/api/users/search/${email}`);
    return data;
  },

  // add user to account
  addUserToAccount: async (payload: AddUserToAccount[]): Promise<any> => {
    const { data } = await apiClient.post('/accounts/account-member', payload);
    return data;
  },

  // get accounts for user
  getAccountsForAccess: async (userId: number) => {
    const { data } = await apiClient.get(`/accounts/access-accounts/${userId}`);
    return data;
  },

  // revoke account access
  revokeAccountAccess: async (payload) => {
    const { data } = await apiClient.post(
      '/accounts/account-member-remove',
      payload
    );
    return data;
  },

  // get account region wise
  getRegionWiseAccounts: async (region: string): Promise<any> => {
    const { data } = await apiClient.get(`/accounts/region/${region}`);
    return data;
  },

  // set as default account
  setAsDefaultAccount: async (accountId: number): Promise<any> => {
    const { data } = await apiClient.patch(
      `/accounts/setAsDefault/${accountId}`
    );
    return data;
  },

  // get account connection limits
  getAccountLimits: async (): Promise<any> => {
    const { data } = await apiClient.get('/accounts/limits');
    return data;
  },
};
